/* MUDNAAZ Card Enhancements - Color swatches, Size pills, Quick View, Mini ATC */
(function () {
  'use strict';
  const COLOR_MAP = {
    black:'#0a0a0a', white:'#ffffff', ivory:'#F7F3EC', cream:'#F5F0E0',
    beige:'#F0EAD6', ecru:'#f5f0e8', gold:'#C9A84C', champagne:'#f7e7ce',
    navy:'#1a2744', blue:'#2563eb', teal:'#0d9488',
    red:'#dc2626', maroon:'#7f1d1d', burgundy:'#881337', rust:'#b45309',
    green:'#16a34a', olive:'#65a30d', sage:'#86a78c', mint:'#a7f3d0',
    grey:'#9ca3af', gray:'#9ca3af', charcoal:'#374151', silver:'#c0c0c0',
    brown:'#92400e', camel:'#c19a6b', tan:'#d2b48c',
    pink:'#ec4899', blush:'#fbb6ce', peach:'#fca5a5', coral:'#f97316',
    nude:'#d4a89a', rose:'#f43f5e', purple:'#7c3aed', lavender:'#c4b5fd',
    yellow:'#f59e0b', mustard:'#ca8a04', orange:'#ea580c', lilac:'#c8a2c8',
  };
  function colorHex(name) {
    const lower = (name || '').toLowerCase().trim();
    for (const [k, v] of Object.entries(COLOR_MAP)) { if (lower === k || lower.includes(k)) return v; }
    return '#d4d4d4';
  }
  const cache = {};
  async function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    try { const r = await fetch('/products/' + handle + '.js'); if (!r.ok) return null; cache[handle] = await r.json(); return cache[handle]; } catch { return null; }
  }
  function handleFromCard(card) {
    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    const m = a.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }
  function addToCart(variantId, btn) {
    const orig = btn.textContent;
    btn.textContent = 'Adding\u2026'; btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(variantId), quantity: 1 }) })
    .then(r => r.json()).then(() => {
      btn.textContent = '\u2713 Added'; btn.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      const bubble = document.querySelector('[data-cart-icon-bubble]');
      if (bubble) bubble.dispatchEvent(new Event('click', { bubbles: true }));
      setTimeout(() => { btn.textContent = orig; btn.classList.remove('is-added'); btn.disabled = false; }, 2500);
    }).catch(() => { btn.textContent = 'Try again'; btn.disabled = false; setTimeout(() => { btn.textContent = orig; }, 2000); });
  }
  let modal = null, qvVariantId = null;
  function buildModal() {
    const el = document.createElement('div');
    el.id = 'mn-qv-modal'; el.className = 'mn-qv-modal';
    el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true');
    el.innerHTML = '<div class="mn-qv-backdrop"></div><div class="mn-qv-panel"><button class="mn-qv-close" aria-label="Close"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button><div class="mn-qv-grid"><div class="mn-qv-media"><img class="mn-qv-img" src="" alt="" loading="lazy"></div><div class="mn-qv-info"><p class="mn-qv-vendor"></p><h2 class="mn-qv-title"></h2><div class="mn-qv-price-row"></div><div class="mn-qv-options"></div><button class="mn-qv-atc-btn">Add to Cart</button><a class="mn-qv-full-link" href="#">View full details \u2192</a></div></div></div>';
    document.body.appendChild(el);
    el.querySelector('.mn-qv-backdrop').addEventListener('click', closeQV);
    el.querySelector('.mn-qv-close').addEventListener('click', closeQV);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeQV(); });
    el.querySelector('.mn-qv-atc-btn').addEventListener('click', function () { if (qvVariantId) addToCart(qvVariantId, this); });
    return el;
  }
  function openQV(product) {
    if (!modal) modal = buildModal();
    const v0 = product.variants.find(v => v.available) || product.variants[0];
    qvVariantId = v0.id;
    modal.querySelector('.mn-qv-vendor').textContent = product.vendor || '';
    modal.querySelector('.mn-qv-title').textContent = product.title;
    modal.querySelector('.mn-qv-full-link').href = '/products/' + product.handle;
    const img = product.images[0] ? product.images[0].src : '';
    modal.querySelector('.mn-qv-img').src = img;
    modal.querySelector('.mn-qv-img').alt = product.title;
    renderQVPrice(v0); renderQVOptions(product);
    const atcBtn = modal.querySelector('.mn-qv-atc-btn');
    atcBtn.textContent = v0.available ? 'Add to Cart' : 'Sold Out';
    atcBtn.disabled = !v0.available; atcBtn.classList.remove('is-added');
    modal.classList.add('is-open'); document.body.style.overflow = 'hidden';
  }
  function closeQV() { modal && modal.classList.remove('is-open'); document.body.style.overflow = ''; }
  function renderQVPrice(variant) {
    const price = formatMoney(variant.price);
    const comp = variant.compare_at_price;
    let html = '<span class="mn-qv-price-now">' + price + '</span>';
    if (comp && comp > variant.price) html += '<span class="mn-qv-price-was">' + formatMoney(comp) + '</span>';
    modal.querySelector('.mn-qv-price-row').innerHTML = html;
  }
  function renderQVOptions(product) {
    const el = modal.querySelector('.mn-qv-options'); el.innerHTML = '';
    product.options.forEach(opt => {
      if (opt.name === 'Title' && opt.values[0] === 'Default Title') return;
      const isColor = /colou?r/i.test(opt.name);
      const group = document.createElement('div'); group.className = 'mn-qv-opt-group';
      const valuesHTML = opt.values.map(v => isColor
        ? '<button class="mn-qv-sw mn-qv-sw--color" data-value="' + v + '" title="' + v + '" style="background:' + colorHex(v) + '"></button>'
        : '<button class="mn-qv-sw mn-qv-sw--size" data-value="' + v + '">' + v + '</button>').join('');
      group.innerHTML = '<p class="mn-qv-opt-label">' + opt.name + '</p><div class="mn-qv-opt-vals">' + valuesHTML + '</div>';
      el.appendChild(group);
      group.querySelector('.mn-qv-sw') && group.querySelector('.mn-qv-sw').classList.add('is-sel');
      group.querySelectorAll('.mn-qv-sw').forEach(btn => { btn.addEventListener('click', () => { group.querySelectorAll('.mn-qv-sw').forEach(b => b.classList.remove('is-sel')); btn.classList.add('is-sel'); updateQVVariant(product); }); });
    });
  }
  function updateQVVariant(product) {
    const selected = [];
    modal.querySelectorAll('.mn-qv-opt-group').forEach(g => { const s = g.querySelector('.mn-qv-sw.is-sel'); if (s) selected.push(s.dataset.value); });
    const variant = product.variants.find(v => v.options.every((o, i) => o === selected[i]));
    if (!variant) return;
    qvVariantId = variant.id; renderQVPrice(variant);
    if (variant.featured_image && variant.featured_image.src) modal.querySelector('.mn-qv-img').src = variant.featured_image.src;
    const atcBtn = modal.querySelector('.mn-qv-atc-btn');
    atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out'; atcBtn.disabled = !variant.available;
  }
  function formatMoney(cents) { return '\u20b9' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  async function enhanceCard(card) {
    if (card.dataset.mnCe) return; card.dataset.mnCe = '1';
    const handle = handleFromCard(card); if (!handle) return;
    const product = await fetchProduct(handle); if (!product) return;
    const colorOpt = product.options.find(o => /colou?r/i.test(o.name));
    const sizeOpt = product.options.find(o => /size|fit/i.test(o.name));
    const firstAvail = product.variants.find(v => v.available) || product.variants[0];
    const wrap = document.createElement('div'); wrap.className = 'mn-ce';
    if (colorOpt && colorOpt.values.length > 1) {
      const row = document.createElement('div'); row.className = 'mn-ce-colors';
      colorOpt.values.slice(0, 6).forEach((v, i) => {
        const btn = document.createElement('button');
        btn.className = 'mn-ce-swatch' + (i === 0 ? ' is-active' : ''); btn.dataset.value = v; btn.title = v;
        btn.style.background = colorHex(v); btn.type = 'button';
        btn.addEventListener('click', e => {
          e.preventDefault();
          row.querySelectorAll('.mn-ce-swatch').forEach(b => b.classList.remove('is-active')); btn.classList.add('is-active');
          const imgVariant = product.variants.find(vv => vv.options.includes(v) && vv.featured_image);
          if (imgVariant && imgVariant.featured_image) { const img = card.querySelector('.card__media img'); if (img) img.src = imgVariant.featured_image.src; }
        });
        row.appendChild(btn);
      });
      if (colorOpt.values.length > 6) { const more = document.createElement('span'); more.className = 'mn-ce-more'; more.textContent = '+' + (colorOpt.values.length - 6); row.appendChild(more); }
      wrap.appendChild(row);
    }
    if (sizeOpt && !(sizeOpt.values.length === 1 && sizeOpt.values[0] === 'Default Title')) {
      const row = document.createElement('div'); row.className = 'mn-ce-sizes';
      sizeOpt.values.slice(0, 7).forEach(v => {
        const avail = product.variants.some(vv => vv.options.includes(v) && vv.available);
        const btn = document.createElement('button'); btn.type = 'button';
        btn.className = 'mn-ce-size' + (!avail ? ' is-out' : ''); btn.textContent = v; btn.dataset.value = v;
        if (avail) { btn.addEventListener('click', e => { e.preventDefault(); row.querySelectorAll('.mn-ce-size').forEach(b => b.classList.remove('is-active')); btn.classList.add('is-active'); const colorVal = wrap.querySelector('.mn-ce-swatch.is-active') ? wrap.querySelector('.mn-ce-swatch.is-active').dataset.value : null; const variant = product.variants.find(vv => vv.options.includes(v) && (!colorVal || vv.options.includes(colorVal)) && vv.available) || product.variants.find(vv => vv.options.includes(v)); if (variant) { const atcBtn = wrap.querySelector('.mn-ce-atc'); atcBtn.dataset.variantId = variant.id; atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out'; atcBtn.disabled = !variant.available; } }); }
        row.appendChild(btn);
      });
      wrap.appendChild(row);
    }
    const actions = document.createElement('div'); actions.className = 'mn-ce-actions';
    const qvBtn = document.createElement('button'); qvBtn.type = 'button'; qvBtn.className = 'mn-ce-qv';
    qvBtn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg> Quick View';
    qvBtn.addEventListener('click', e => { e.preventDefault(); openQV(product); });
    const atcBtn = document.createElement('button'); atcBtn.type = 'button'; atcBtn.className = 'mn-ce-atc';
    atcBtn.dataset.variantId = firstAvail.id;
    atcBtn.textContent = firstAvail.available ? 'Add to Cart' : 'Sold Out'; atcBtn.disabled = !firstAvail.available;
    atcBtn.addEventListener('click', e => { e.preventDefault(); addToCart(atcBtn.dataset.variantId, atcBtn); });
    actions.appendChild(qvBtn); actions.appendChild(atcBtn); wrap.appendChild(actions);
    const info = card.querySelector('.card__information');
    if (info) info.after(wrap);
    else { var c = card.querySelector('.card__content'); if (c) c.appendChild(wrap); else card.appendChild(wrap); }
  }
  function init() {
    const cards = document.querySelectorAll('.card-wrapper');
    cards.forEach((card, i) => {
      if (i < 4) enhanceCard(card);
      else { card.addEventListener('mouseenter', () => enhanceCard(card), { once: true }); card.addEventListener('focusin', () => enhanceCard(card), { once: true }); }
    });
    if (window.MutationObserver) {
      new MutationObserver(mutations => {
        mutations.forEach(m => { m.addedNodes.forEach(node => { if (node.nodeType !== 1) return; const newCards = node.matches && node.matches('.card-wrapper') ? [node] : (node.querySelectorAll ? Array.from(node.querySelectorAll('.card-wrapper')) : []); newCards.forEach((card, i) => { if (i < 2) enhanceCard(card); else card.addEventListener('mouseenter', () => enhanceCard(card), { once: true }); }); }); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
